module.exports = __webpack_public_path__ + "img/oficina-centro.126388f8.jpg";